<template>
  <div>
    <a-button class="editable-add-btn" @click="showModal()">Add</a-button>
    <a-modal-scope
      ref="scopeModalForm"
      :visible="visible"
      :permission="permission"
      :description="description"
      :title="title"
      :isUpdate="isUpdate"
      :resource="data.uuid"
      @cancel="handleCancel"
      @create="handleCreate"
    />
    <a-skeleton active :loading="loading" :title="false" :paragraph="{ rows: 8, width: 800 }">
      <a-table :columns="columns" :dataSource="data" :rowKey="record => record.uuid">
        <template v-for="col in ['permission', 'description']" :slot="col" slot-scope="text">
          <div :key="col">
            <template v-if="col == 'permission'"><a-tag color="purple">{{text}}</a-tag></template>
            <template v-else>{{text}}</template>
          </div>
        </template>
        <template slot="operation" slot-scope="text, record">
          <div class="editable-row-operations">
            <a-popconfirm
              v-if="data.length"
              title="Sure to delete?"
              @confirm="() => onDelete(record.permission)"
            >
            <a href="javascript:;"><a-button type="danger" icon="delete">Delete</a-button></a>
            </a-popconfirm>
          </div>
        </template>
      </a-table>
    </a-skeleton>
  </div>
</template>

<script>
import AModalScope from "@/components/FormSet/AModalScope";

const columns = [
  {
    title: "Permission",
    dataIndex: "permission",
    width: "30%",
    scopedSlots: {
      customRender: "permission"
    }
  },
  {
    title: "Description",
    dataIndex: "description",
    width: "30%",
    scopedSlots: {
      customRender: "description"
    }
  },
  {
    title: "",
    dataIndex: "operation",
    scopedSlots: {
      customRender: "operation"
    }
  }
];

export default {
  data() {
    return {
      columns,
      loading: true,
      visible: false,
      permission: "",
      description: "",
      isUpdate: false,
      title: "Create Scope"
    };
  },

  computed: {
    data() {
      return this.$store.state.tenant.scopes? this.$store.state.tenant.scopes: [];
    }
  },

  components: {
    AModalScope
  },

  methods: {
    handleCancel() {
      this.visible = false;
      this.permission = "";
      this.description = "";
      this.isUpdate = false;
      this.title = "Create Scope";
    },

    showModal() {
      this.visible = true;
    },

    handleCreate() {
      const form = this.$refs.scopeModalForm.form;
      form.validateFields(async (err, values) => {
        if (!err) {
          console.log(values);
          values.resource = this.$route.params.uuid;
          try {
            await this.$store.dispatch("tenant/createItem", {
              endpoint: "scopes",
              data: values
            });
            await this.$store.dispatch("tenant/getItems", {
              endpoint: "scopes",
              params: { resource: this.$route.params.uuid }
            });
            this.handleCancel();
            form.resetFields();
          } catch (error) {
            console.error(error);
            form.setFields({
              permission: {
                value: values.permission,
                errors: [new Error("This permission already exists")]
              }
            });
          }
        } else {
          console.error("Error! Check submitted values : ", values);
        }
      });
    },

    async onDelete(permission) {
      let perm = this.data.find(o => o.permission === permission);
      try {
        await this.$store.dispatch("tenant/deleteItem", {
          endpoint: "scopes",
          uuid: perm.uuid
        });
        await this.$store.dispatch("tenant/getItems", {
          endpoint: "scopes",
          params: { resource: this.$route.params.uuid }
        });
      } catch (error) {
        console.error(error);
      }
    }
  },
  beforeCreate: async function() {
    this.form = this.$form.createForm(this);
    try {
      await this.$store.dispatch("tenant/getItems", {
        endpoint: "scopes",
        params: { resource: this.$route.params.uuid }
      });
      this.loading = false;
    } catch (error) {
      console.error(error);
      this.loading = false;
    }
  }
};
</script>

<style lang="css">
.editable-add-btn {
  margin-bottom: 10px;
}
</style>
